/**
 * Renders HTML snippets returned by the OPSI WordPress ACF fields.
 */

import { hasHtmlContent } from "./opsiHelpers";

export const OpsiHtmlContent = ({
  html,
  as: Tag = "div",
  className = "opsi-html text-[1rem]",
}) => {
  if (!hasHtmlContent(html)) {
    return null;
  }

  return (
    <Tag
      className={className}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};
